/**
 * Feature flags. Build-time env vars flip a flag for a whole deploy;
 * the localStorage override flips it per-device on production builds
 * without a redeploy (set in the console, reload to apply).
 *
 * Flags are read once at module load — a mid-session localStorage change
 * applies on the next reload, never mid-render (keeps hook order stable
 * where a flag gates an early return).
 */

/** Default-ON flag with two kill-switches: env `=== 'false'` (whole deploy)
 *  or localStorage `'false'` (this device). */
function flagDefaultOn(envValue, storageKey) {
  if (envValue === 'false') return false;
  try {
    if (typeof localStorage !== 'undefined' && localStorage.getItem(storageKey) === 'false') {
      return false;
    }
  } catch {
    // storage blocked (private mode) — flag stays on
  }
  return true;
}

/**
 * PR 2 plot canvas — FLIPPED ON 2026-09-09 (launch decision). Kill switch:
 * REACT_APP_SCROLL_CANVAS=false at build time, or per-device
 *   localStorage.setItem('pangaji_scroll_canvas', 'false')
 */
export const SCROLL_CANVAS = flagDefaultOn(process.env.REACT_APP_SCROLL_CANVAS, 'pangaji_scroll_canvas');
